export const POST_Withdraw_START = "POST_Withdraw_START";
export const POST_Withdraw_SUCCESS = "POST_Withdraw_SUCCESS";
export const POST_Withdraw_FAIL = "POST_Withdraw_FAIL";
export const GET_WithdrawS_START = "GET_WithdrawS_START";
export const GET_WithdrawS_SUCCESS = "GET_WithdrawS_SUCCESS";
